//frontend/src/pages/history/historystages/Contemporary.jsx
import React from 'react';
import JourneyPage from '../../../components/SubjectsPage';
import historyImage from '../../../assets/history2/Historical_Topics_-_Contemporary_Period.png';

const subTopics = [
  { name: 'Globalization', route: '/History-Globalization', key: 'Globalization' },
  { name: 'Digital Revolution', route: '/History-Digital-Revolution', key: 'Digital Revolution' },
  { name: 'Climate Change and Environmental Movements', route: '/History-Climate-Change', key: 'Climate Change and Environmental Movements' },
  { name: 'Rise of China', route: '/History-Rise-of-China', key: 'Rise of China' },
  { name: 'Modern Conflicts (e.g., Middle East, Ukraine)', route: '/History-Modern-Conflicts', key: 'Modern Conflicts (e.g., Middle East, Ukraine)' },
  { name: 'Social Movements (e.g., Civil Rights, LGBTQ+)', route: '/History-Social-Movements', key: 'Social Movements (e.g., Civil Rights, LGBTQ+)' }
];



function HistoryPageContemporary() {
  return (
    <JourneyPage
      title="The Contemporary Age"
      backgroundImage={historyImage}
      subTopics={subTopics}
      backRoute="/history2"
      chapterFooter=""
    />
  );
}

export default HistoryPageContemporary;
